// extracted by mini-css-extract-plugin
export default {"zoomModal":"x2-z","image":"y2-z","button":"z2-z","isOverlayShown":"A2-z"};